import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BankingAlertsComponent from '../components/BankingAlerts/bankingAlertsPage';
import {
    bankingAlerts,
    accountAlerts,
    getContactPreferences,
    removeContactPreferences,
    addContactPreferences,
    getDeliveryChannels
} from "../actions/actions";
import _ from "lodash";

const mapStateToProps = (state, ownProps) => ({
    bankingAlertItem: state.bankingAlertsReducer.items.find(
        s => s.name.toString() === ownProps.match.params.name
    ),
    deliveryChannels: state.bankingAlertsReducer.deliveryChannelConfig,
    loadingState: state.bankingAlertsReducer.loadingState,
    bankingAlertsState: state.bankingAlertsReducer.bankingAlertsState,
    contactPreferenceState: state.bankingAlertsReducer.contactPreferenceState,
    bankingEnableAlertState: state.accountAlertsReducer.bankingEnableAlertState,
    deliveryAddresses: _.get(state.accountAlertsReducer, "items.deliveryMethods", []),
    contactPreferences: _.get(state.accountAlertsReducer, "contactPreferences")  
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            accountAlerts,
            bankingAlerts,
            getContactPreferences,
            addContactPreferences,
            removeContactPreferences,
            getDeliveryChannels
        },
        dispatch
    );
};
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(BankingAlertsComponent);
